import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface IMiniBarChartProps {
  data: { label: string; value: number }[];
  maxVal: number;
  color: string;
}

const MiniBarChart = ({ data, maxVal, color }: IMiniBarChartProps) => (
  <div className="mini-bar-chart">
    {data.map((d, i) => (
      <OverlayTrigger
        key={i}
        placement="top"
        overlay={<Tooltip id={`bar-${i}`}>{d.label}: {d.value}</Tooltip>}
      >
        <div className="mini-bar-wrapper">
          <div
            className="mini-bar"
            style={{
              height: `${Math.max(4, (d.value / maxVal) * 100)}%`,
              backgroundColor: color,
            }}
          />
        </div>
      </OverlayTrigger>
    ))}
  </div>
);

export default MiniBarChart;
